import React from 'react';
import PropTypes from 'prop-types';
import HorizontalScroll from '../Global/Containers/HorizontalScroll';
import ImageOverlayTeaser from '../Global/Teasers/ImageOverlayTeaser';

const TrainingGroundFeaturePromos = () => {
  const gridClass = `col-md-6`;

  return (
    <div className="training-ground-feature-promos">
      <HorizontalScroll size="l" grid>
        <ul className="row">
          <li className={gridClass}>
            <ImageOverlayTeaser
              title="Design Tools"
              subtitle="Create your own diagrams, practices and sessions with our suite of easy to use tools."
              ctaText="Create a diagram"
              ctaLink="/locker/my-content"
            />
          </li>

          <li className={gridClass}>
            <ImageOverlayTeaser
              title="Season Plans"
              subtitle="Create a customised Season Plan for your team and players. Save yourself valuable coaching time."
              ctaText="Create a season plan"
              ctaLink="/locker/season-plans"
            />
          </li>
        </ul>
      </HorizontalScroll>
    </div>
  );
};

TrainingGroundFeaturePromos.propTypes = {

};

export default TrainingGroundFeaturePromos;



// WEBPACK FOOTER //
// ./library/app/components/TrainingGround/TrainingGroundFeaturePromos.js